import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CustomTypography } from "../../../../sipli-fleet-core/components";

export interface WarehouseBreadcrumbItem {
  label: string;
  path?: string;
}

interface WarehouseBreadcrumbProps {
  items: WarehouseBreadcrumbItem[];
}

const WarehouseBreadcrumb = ({ items }: WarehouseBreadcrumbProps) => {
  const { t } = useTranslation();

  if (items.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label={t("warehouse_breadcrumb")}
      className="flex flex-wrap items-center gap-2 text-[12px] text-gray8 mt-1"
    >
      {items.map((item, index) => {
        const content = item.path ? (
          <Link
            to={item.path}
            className="max-w-[180px] truncate hover:text-primary transition-colors !font-[400] leading-[18px]"
          >
            {item.label}
          </Link>
        ) : (
          <span className="max-w-[180px] truncate text-gray9 font-medium !font-[400] leading-[18px]">
            {item.label}
          </span>
        );

        return (
          <CustomTypography.CustomText
            key={`${item.label}-${index}`}
            className="flex items-center min-w-0 gap-2"
          >
            {index > 0 && <span aria-hidden="true" className="text-gray9 !font-[400] leading-[18px]">{'>'}</span>}
            {content}
          </CustomTypography.CustomText>
        );
      })}
    </nav>
  );
};

export default WarehouseBreadcrumb;
